module.exports = __webpack_public_path__ + "static/media/08.9c7592e1.jpg";